/** Pendant zu `Services/Core/AuthService.cs` — nur die HTTP-Aufrufe. */

import type { App, ChinaAppSysGroup, ChinaAppSysUser } from '@/types/entities';

import { apiClient, readJson } from '../httpClient';

/**
 * Die App-Liste wird vor der App-Auswahl geladen und hat deshalb kein App-Präfix im Pfad;
 * Benutzer und Gruppen bekommen die App-URI übergeben, weil sie im `AuthContext` erst
 * nach diesen Aufrufen gesetzt wird.
 */
export const authApi = {
  getApps(): Promise<App[]> {
    return apiClient.get<App[]>('v1/auth/me/apps');
  },

  async getMe(appUri: string): Promise<ChinaAppSysUser | null> {
    const response = await apiClient.raw('GET', `v1/${appUri}/users/me`);
    return response.ok ? readJson<ChinaAppSysUser>(response) : null;
  },

  async getMyGroups(appUri: string): Promise<ChinaAppSysGroup[] | null> {
    const response = await apiClient.raw('GET', `v1/${appUri}/groups/my`);
    return response.ok ? readJson<ChinaAppSysGroup[]>(response) : null;
  },
};
